<app-compose-mail appendTo='body' style="z-index: 9999999;" ></app-compose-mail>
<form>


    <div class="row">

        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-card>
                <h3>
                    <span style="width: 180;height: 100;background-color: #FDE2C2;color: #2C3F91;padding: 3px;">
                     Attacher   Contrat PDF
                    </span>
                 

                    <button mat-icon-button (click)="attache('#contratBrows')">
                        <mat-icon   style="color: #E30635;" class="mat-18">cloud_upload</mat-icon>

                    </button>

                    <button mat-icon-button (click)="getClientContract(true,false)">
                        <mat-icon  style="color: #E30635;"  class="mat-18">cloud_download</mat-icon>

                    </button>
                </h3>

                <img src="/assets/img/contract.png" *ngIf="!fileURL" height="300" (click)="attache('#pjointBrows')">
                <pdf-viewer [src]="fileURL" *ngIf="fileURL" style='height:300'></pdf-viewer>
            </mat-card>
        </div>


        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>
                        <h5>    Autre Attachement <button mat-icon-button  (click)="attache('#pjointBrows')">
                                <mat-icon class="mat-18">cloud_upload</mat-icon>

                            </button>
                          </h5>
                          <button mat-stroked-button cdkFocusInitial style="background: #FFF4E9;" (click)="sendContractClient()">Envoyer
                            Dossier</button>
                      

                    </mat-card-title>




                </mat-card-header>
                <mat-card-content>


                    <mat-list-item *ngFor="let pjoint of pjoints">
                            <h6 mat-line> 
<span style="cursor: pointer;color: rgb(5, 112, 206);text-decoration: underline;" (click)="openPjoint(pjoint,true)">
    <mat-icon class="mat-18">note</mat-icon>
    {{pjoint.designation}}
</span>

                              

                      <button mat-icon-button (click)="remove(pjoint)">
                            <mat-icon class="mat-18">delete</mat-icon>

                        </button>
                    </h6>
                        <p mat-line> {{pjoint.taille}} </p>
                       
                    </mat-list-item>
                    <mat-form-field class="full-width" style="margin: 5mm;">
                        <textarea matInput [(ngModel)]="observationd"  (keyup)='editRemarqu()'
                         [ngModelOptions]="{standalone: true}"  placeholder="Notes" rows="7"></textarea>
                      </mat-form-field>

                </mat-card-content>

            </mat-card>
        </div>


    </div>

    <div style="display: none" id='contratBrows'>
        <p-fileUpload id="uploads" mode="basic" name="demo[]" url="{{uploadUrl}}" maxFileSize="100000000"
            (onUpload)="onUploadContrat($event)" auto="true" chooseLabel="Attachement">
        </p-fileUpload>
    </div>

    <div style="display: none" id='pjointBrows'>
        <p-fileUpload id="uploads" mode="basic" name="demo[]" url="{{uploadUrl}}" maxFileSize="100000000"
            (onUpload)="onUploadPjoint($event)" auto="true" chooseLabel="Attachement">
        </p-fileUpload>
    </div>
</form>